export const formatPhone = (phone: string) => (phone ? `+${phone}` : '');
